import {Controller} from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import {TextField} from "@mui/material";
import React from "react";

import type {Control, FieldValues, Path, RegisterOptions} from "react-hook-form";

/**
 * Genérico con default en FieldValues: los módulos que todavía no tipan su formulario lo
 * usan igual que antes, y los que hagan `useForm<AlgunDto>()` ganan chequeo del `name`
 * contra los campos reales del DTO sin tocar este componente.
 */
export interface InputControllerProps<T extends FieldValues = FieldValues> {
    control: Control<T>;
    name: Path<T>;
    label: string;
    rules?: RegisterOptions<T>;
    type?: string;
    defaultValue?: unknown;
    disabled?: boolean;
}

const InputController = <T extends FieldValues = FieldValues>({control, name, label, rules, type, defaultValue, disabled = false}: InputControllerProps<T>) => {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue as never}
            rules={rules as never}
            render={({field}) => (
                <FormControl fullWidth>
                    <TextField
                        label={label}
                        margin="dense"
                        disabled={disabled}
                        fullWidth
                        type={type}
                        {...field}
                        name={name}
                        id="formatted-numberformat-input"
                        variant="outlined"
                    />
                </FormControl>
            )}
        />
    )
}

export default InputController;
